import React from "react";
import styled from "styled-components";
import license1 from "../../assets/license/license1.png";
import license2 from "../../assets/license/license2.png";
import license3 from "../../assets/license/license3.png";
import license4 from "../../assets/license/license4.png";
const cdn_url = process.env.REACT_APP_CDN_API_SERVER_URL;
const logo = `${cdn_url}/assets/eden-financial-logo-mobile.svg`;

function LicenseModal({ showLicenseModal, setShowLicenseModal }) {
  React.useEffect(() => {
    if (showLicenseModal.show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showLicenseModal]);

  const closeLicense = () => {
    setShowLicenseModal((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  if (!showLicenseModal.show) return null;

  return (
    <ModalOverlay>
      <ModalBox>
        <ModalHeaderLogo>
          <img src={logo} alt="이든 파이낸셜" />
        </ModalHeaderLogo>
        <ModalHeader>
          <h2>{showLicenseModal.title}</h2>
        </ModalHeader>
        <ModalBody>
          <img
            src={
              showLicenseModal.id === "1"
                ? license1
                : showLicenseModal.id === "2"
                  ? license2
                  : showLicenseModal.id === "3"
                    ? license3
                    : license4
            }
            alt="license"
            className="LicenseImg"
          />
        </ModalBody>
        <ModalFooter>
          <button onClick={closeLicense}>닫기</button>
        </ModalFooter>
      </ModalBox>
    </ModalOverlay>
  );
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ModalBox = styled.div`
  background: #fff;
  border-radius: 16px;
  max-width: 90vw;
  width: 350px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ModalHeaderLogo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px 0 0 0;
  img { height: 32px; }
`;
const ModalHeader = styled.div`
  width: 100%;
  text-align: center;
  padding: 8px 0 0 0;
  h2 { font-size: 18px; font-weight: 700; color: #222; }
`;
const ModalBody = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  img.LicenseImg {
    width: 90%;
    max-width: 300px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
`;
const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 0 24px 0;
  button {
    background: #00b8c3;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
`;

export default LicenseModal;
